import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button, Card } from "react-bootstrap";

const NotFoundPage = () => {
  return (
    <Container className="d-flex vh-100 align-items-center justify-content-center">
      <Card className="text-center p-5 shadow-lg">
        <h1 className="display-1 fw-bold text-danger">404</h1>
        <h2 className="display-5 fw-bold">Page Not Found</h2>
        <p className="lead fw-bolder">
          Oops, we can't seem to find the page you're looking for.
        </p>
      </Card>
    </Container>
  );
};

export default NotFoundPage;
